var d = /* @__PURE__ */ ((e) => (e.Idle = "idle", e.Pending = "pending", e.Succeeded = "succeeded", e.Failed = "failed", e))(d || {});
export {
  d as LoadingEnum
};
